<template>
    <div>
        <div>
            <c-search-form
                    :input-search-items="searchItemsWaiting"
                    :rows-per-page-items="[10,20,50]"
                    :input-create-items="createItemsWaiting"
                    :fields="fieldsWaiting"
                    :search-div="'searchDivWaiting'"
                    :create-div="'searchDivWaiting'"
                    :displayToolbar="false"
                    key-property="requestId"
                    :search-url="searchUrlWaiting"
                    form-type="intable"
                    @onChooseRequest="onChooseRequest"
                    ref="waitingRequestForm"
            />

            <div style="text-align: right">
                <v-spacer></v-spacer>
                <v-btn @click="onCancel" width="200">
                    {{$t("lang.common.close")}}
                </v-btn>
            </div>
        </div>


    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../../../components/form/Upload";
    import CSearchForm from "../../../components/form/ManageForm";

    export default {
        name: "waiting-request-component",
        components: {IUpload, CSearchForm},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
            requestComponentDlg: {
                type: Boolean,
                default: false,
            }
        },

        data: () => ({
            searchItemsWaiting: [],
            createItemsWaiting: [],
            searchUrlWaiting: "",
            fieldsWaiting: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center"
                },
                {
                    value: 'subject',
                    text: 'lang.request.subject',
                    width: "15%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },
                {
                    type: "select",
                    items: [],
                    itemText: "name",
                    itemValue: "id",
                    name: 'customerId',
                    value: 'customerId',
                    text: 'lang.request.customerId',
                    width: "10%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },

                {
                    type: "upload",
                    value: 'attachIds',
                    text: 'lang.request.fileIds',
                    width: "10%",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:left"
                },
                {
                    value: 'custom_action',
                    text: "lang.request.choose",
                    icon: "add",
                    event: "onChooseRequest",
                    width: "10%",
                    color: "primary"
                }
            ],

        }),

        watch: {},

        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {
                    let itemFields = this.fieldsWaiting.filter(function(e) {
                        return e.name == "customerId";
                    });
                    if(itemFields != undefined && itemFields.length > 0){
                        itemFields[0].items = data.items;
                    }
                }
            )
        },
        methods: {
            viewWaitingRequest(item) {
                this.files = item;
                this.searchUrlWaiting = "/files/request/waitingList"
            },
            cancelWaitingRequest() {
                this.searchUrlWaiting = "";
            },

            onChooseRequest(item) {
                item['fileId'] = this.files['fileId'];
                item['isSendToFile'] = 1;
                axios.post(process.env.VUE_APP_API_URL + "/request/save", item).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                            this.$refs.waitingRequestForm.search();
                        } else {
                            message.error(data.description);
                        }
                    }
                )


            },

            onSave() {

                axios.post(process.env.VUE_APP_API_URL + "/procedure/document/saveAll", this.items).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                            this.getRequest();
                        } else {
                            message.error(data.description);
                        }
                    }
                )

            },

            onCancel() {
                this.$emit("cancel");

            }


        }
    };
</script>